export const MAX_PAYMENT_AMOUNT = 23_000_00;
export const SOURCE_QUERY_PARAM_KEY = "source";
export const ORG_PAGE_SOURCE = "org-page";
export const ORG_PAGE_CONTACT_MESSAGE_MAX_LENGTH = 2_000;
export const MAX_DONATION_FORM_FREQUENCIES = 4;
export const MAX_SUGGESTED_AMOUNTS_PER_FREQUENCY = 4;
export const SUGGESTED_AMOUNTS_COUNT_OPTIONS = [0, 2, 3, 4];
export const DEFAULT_SUGGESTED_AMOUNTS_COUNT = 4;
export const MAX_PAYMENT_AMOUNT_WITHOUT_TIP = 20_000_00;
export const SEPA_MAX_PAYMENT_AMOUNT = 10_000_00;
export const DEFAULT_CHEQUE_MINIMUM_AMOUNT = 1_000_00;
export const AUCTION_CASH_CHEQUE_MINIMUM_AMOUNT = 0;
